import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ModalDelete from '../Modal';
import history from '../../history';
import { fetchPartner, deletePartner } from './actions';
import { Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';


class PartnerDelete extends React.Component{
    componentDidMount(){
        this.props.fetchPartner(this.props.match.params.id);
    }
    renderActions(){
        const id = this.props.match.params.id;
        return (
            <React.Fragment>
                <Button onClick={() => this.props.deletePartner(id)} className="primary">Eliminar</Button>
                <Link to="/Upd_Delete_partners" className="secondary">Cancelar</Link>
            </React.Fragment>
        );
    }

renderContent(){
    if(this.props.partner){
        return `Está seguro que quiere borrar el partner con el id: ${this.props.partner.id}`            
} else {
    history.push('/Upd_Delete_partners');
}
}

render(){
    if (!this.props.partner){      
    return (<Redirect to={{
      pathname: '/Upd_Delete_partners'
    }}/>)    
}
    return (                   
        <ModalDelete
            title="Eliminar Partner"
            content={this.renderContent()}
            actions={this.renderActions()}
            onDismiss={() => history.push('/')}
        />          
    );
}
}

const mapStateToProps = (state, ownProps) =>{
    return { partner: state.partners[ownProps.match.params.id] }
};

export default connect(mapStateToProps, { fetchPartner, deletePartner })(PartnerDelete);